var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.orderPaymentStatusClasses,domProps:{"innerHTML":_vm._s(_vm.order.paymentStatusLabel)}})}
var staticRenderFns = []

export { render, staticRenderFns }